<template>
<div> <!-- root element start -->


    <div class="container-fluid mt-1">
          <div class="row">
            <div class="col-12">
              <user-dash-user-details></user-dash-user-details>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h5 class="text-muted"> You have no messages or alerts.</h5>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-6  border-xl-right">


              <div class="row">
                <div class="col-12">

                  <a href="/bidmanager/bm-quote-page" class="text-secondary"  style="text-decoration:none">
                    <div class="card border-0 py-2 py-xl-1">
                      <div class="row no-gutters">
                        <div class="col-md-3 d-flex align-items-center justify-content-center">
                          <!-- <img src="" class="card-img" alt="missing picture"> -->
                          <i class="fa fa-5x fa-map-o" aria-hidden="true"></i>
                        </div>
                        <div class="col-md-9">
                          <div class="card-body">
                            <h5 class="card-title">Quotes</h5>
                            <p class="card-text">Click here or selct the Quotes section on the sidebar to view all quotes.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

                </div>
              </div>

            </div>


           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/bm-dashboard-main-store.js'

import userDashDetails from '../bmDashComponents/bm-dash-details.vue'






export default {
  store,
  props: ['org_id'],
  data: function () {
    return {

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {

  },
  mounted() {
    this.getUserDetails();

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    getUserDetails() { this.$store.dispatch("getUserDetails"); },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
        // code to run the "get all contacts method" from store
        _this.getLatestUserContacts();

        break;
        case 'org-add':
        // code to run the "get all contacts method" from store
        _this.getLatestUserOrgs();

        break;
        case 'quote-save':
        _this.getLatestUserQuotes();
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {


        default:
      }
    },
    onSecondary(value) {

    },

  },
  components:{
  	'user-dash-user-details': userDashDetails,



  },
  filters: {

  }
}
</script>
